import { useSelector } from "react-redux";
import { permissionsSelector } from "store/bailiff/auth/bailiff_auth.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useClaimToken = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const claim = useSelector(permissionsSelector);
  const permissions = claim ? JSON.parse(claim)?.clients : [];

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { permissions };
};
